import { api } from "./api";

export const plansList = async (params: {
  search?: string;
  status?: boolean;
  free?: string;
}): Promise<
  Array<{
    id: string;
    name: string;
    status: boolean;
    value: string;
    recurrence: string;
    description?: string;
    installments?: string;
    fights: { fightId: string }[];
    free: boolean;
    paymentsType: any;
  }>
> => {
  const { data } = await api.get("store/plans", { params });
  return data;
};

export const plansCreate = async (body: {
  name: string;
  value: string;
  recurrence: string;
  description?: string;
  fights?: string[];
  free?: boolean;
  paymentsType: string[];
}): Promise<any> => {
  const { data } = await api.post("store/plans", body);
  return data;
};

export const plansUpdate = async (body: {
  id: string | number;
  name: string;
  value: string | number;
  recurrence: string;
  description?: string;
  fights?: string[];
  free?: boolean;
  paymentsType: string[];
}): Promise<any> => {
  const { data } = await api.put("store/plans/update", body);
  return data;
};

export const plansDelete = async (body: {
  id: string | number;
}): Promise<any> => {
  const { data } = await api.put("store/plans/delete", body);
  return data;
};
